"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var match_1 = require("./match");
var HttpMockResponse = (function () {
    function HttpMockResponse(context) {
        this.context = null;
        this.context = context;
    }
    Object.defineProperty(HttpMockResponse.prototype, "status", {
        set: function (value) {
            this.context.status = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HttpMockResponse.prototype, "body", {
        set: function (data) {
            this.context.body = data;
        },
        enumerable: true,
        configurable: true
    });
    ;
    HttpMockResponse.prototype.write = function (data) {
        this.context.body += data;
    };
    ;
    HttpMockResponse.prototype.json = function (data, status) {
        if (status === void 0) { status = 200; }
        this.context.status = status;
        this.context.headers['Content-Type'] = 'application/json';
        this.context.body = JSON.stringify(data);
    };
    ;
    HttpMockResponse.prototype.header = function (key, value) {
        this.context.headers[key] = value;
    };
    ;
    return HttpMockResponse;
}());
exports.HttpMockResponse = HttpMockResponse;
var NetworkingLayer = (function () {
    function NetworkingLayer() {
        var _this = this;
        this.requestMiddlewareChain = [];
        this.responseMiddlewareChain = [];
        this.mockedRoutes = [];
        this.baseUrl = '';
        this.timeout = 10000;
        this.internetDelay = 30;
        this.driver = null;
        this.mockGET = function (path, handler) {
            _this.mockedRoutes.push({
                path: path,
                handler: handler,
                method: 'GET',
            });
        };
        this.mockPOST = function (path, handler) {
            _this.mockedRoutes.push({
                path: path,
                handler: handler,
                method: 'POST',
            });
        };
        this.mockPUT = function (path, handler) {
            _this.mockedRoutes.push({
                path: path,
                handler: handler,
                method: 'PUT',
            });
        };
        this.mockDELETE = function (path, handler) {
            _this.mockedRoutes.push({
                path: path,
                handler: handler,
                method: 'DELETE',
            });
        };
        this.mockDRIVER = function (fallback) {
            return function (request) { return __awaiter(_this, void 0, void 0, function () {
                var path, method, oldPath, oldMethod, methodNotFound, _loop_1, this_1, _a, _b, route, state_1, e_1_1;
                var e_1, _c;
                var _this = this;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            path = (request.baseUrl || this.baseUrl) + request.url;
                            method = request.method;
                            oldPath = request.url;
                            oldMethod = request.method;
                            request.url = path;
                            request.method = method;
                            methodNotFound = false;
                            _loop_1 = function (route) {
                                var matchedPath, output_1, res, e_2, obj;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            matchedPath = match_1.match(path, {
                                                path: this_1.baseUrl + route.path,
                                                exact: true,
                                                sensitive: true,
                                                strict: true,
                                            });
                                            if (!matchedPath) return [3, 8];
                                            if (!(route.method === method)) return [3, 7];
                                            output_1 = {
                                                headers: {},
                                                status: 200,
                                                body: '',
                                            };
                                            request.context = request.context || {};
                                            request.context.params = matchedPath.params;
                                            res = new HttpMockResponse(output_1);
                                            _a.label = 1;
                                        case 1:
                                            _a.trys.push([1, 5, , 6]);
                                            if (!this_1.internetDelay) return [3, 3];
                                            return [4, new Promise(function (a) { return setTimeout(a, (250 + Math.random() * 1000) * _this.internetDelay / 100); })];
                                        case 2:
                                            _a.sent();
                                            _a.label = 3;
                                        case 3: return [4, route.handler(request, res)];
                                        case 4:
                                            _a.sent();
                                            return [3, 6];
                                        case 5:
                                            e_2 = _a.sent();
                                            throw {
                                                status: 500,
                                                payload: e_2.toString(),
                                                statusText: 'internal server error',
                                            };
                                        case 6:
                                            output_1.headers = Object.keys(output_1.headers).reduce(function (acc, key) {
                                                acc[key.toLowerCase()] = output_1.headers[key];
                                                return acc;
                                            }, {});
                                            if (output_1.headers['content-type'] === 'application/json') {
                                                try {
                                                    output_1.payload = JSON.parse(output_1.body || '{}');
                                                }
                                                catch (e) {
                                                    throw {
                                                        status: 500,
                                                        payload: output_1.body,
                                                        statusText: 'invalid body',
                                                    };
                                                }
                                            }
                                            else {
                                                output_1.payload = output_1.body;
                                            }
                                            obj = {
                                                status: output_1.status,
                                                payload: output_1.payload,
                                            };
                                            if (obj.status >= 400) {
                                                throw obj;
                                            }
                                            return [2, { value: obj }];
                                        case 7:
                                            methodNotFound = true;
                                            _a.label = 8;
                                        case 8: return [2];
                                    }
                                });
                            };
                            this_1 = this;
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 6, 7, 8]);
                            _a = __values(this.mockedRoutes), _b = _a.next();
                            _d.label = 2;
                        case 2:
                            if (!!_b.done) return [3, 5];
                            route = _b.value;
                            return [5, _loop_1(route)];
                        case 3:
                            state_1 = _d.sent();
                            if (typeof state_1 === "object")
                                return [2, state_1.value];
                            _d.label = 4;
                        case 4:
                            _b = _a.next();
                            return [3, 2];
                        case 5: return [3, 8];
                        case 6:
                            e_1_1 = _d.sent();
                            e_1 = { error: e_1_1 };
                            return [3, 8];
                        case 7:
                            try {
                                if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                            }
                            finally { if (e_1) throw e_1.error; }
                            return [7];
                        case 8:
                            if (methodNotFound) {
                                throw {
                                    status: 405,
                                    statusText: '405 method not allowed',
                                };
                            }
                            if (fallback) {
                                request.url = oldPath;
                                request.method = oldMethod;
                                return [2, fallback(request)];
                            }
                            throw {
                                status: 404,
                                statusText: '404 not found',
                            };
                    }
                });
            }); };
        };
        this.MIDDLEWARE = function (name, middleware) {
            var index = _this.requestMiddlewareChain.findIndex(function (a) { return a.name === name; });
            if (index > -1) {
                if (middleware) {
                    _this.requestMiddlewareChain[index].middleware = middleware;
                }
                else {
                    _this.requestMiddlewareChain.splice(index, 1);
                }
            }
            else {
                _this.requestMiddlewareChain.push({
                    name: name,
                    middleware: middleware,
                });
            }
        };
        this.INTERCEPTOR = function (name, middleware) {
            var index = _this.responseMiddlewareChain.findIndex(function (a) { return a.name === name; });
            if (index > -1) {
                if (middleware) {
                    _this.responseMiddlewareChain[index].middleware = middleware;
                }
                else {
                    _this.responseMiddlewareChain.splice(index, 1);
                }
            }
            else {
                _this.responseMiddlewareChain.push({
                    name: name,
                    middleware: middleware,
                });
            }
        };
        this.GET = function (path, payload) {
            return _this.REQUEST({
                url: path,
                payload: payload || {},
                method: 'GET'
            });
        };
        this.POST = function (path, payload) {
            return _this.REQUEST({
                url: path,
                payload: payload || {},
                method: 'POST',
            });
        };
        this.PUT = function (path, payload) {
            return _this.REQUEST({
                url: path,
                payload: payload || {},
                method: 'PUT'
            });
        };
        this.DELETE = function (path, payload) {
            return _this.REQUEST({
                url: path,
                payload: payload || {},
                method: 'DELETE'
            });
        };
        this.REQUEST = function (request) { return __awaiter(_this, void 0, void 0, function () {
            var requestCache, _a, _b, m, responseCache, e_3, failureCache, _c, _d, m, _e, _f, m;
            var e_4, _g, e_5, _h, e_6, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!this.driver) {
                            throw new Error('NO DRIVER ASSIGNED');
                        }
                        requestCache = request;
                        try {
                            for (_a = __values(this.requestMiddlewareChain), _b = _a.next(); !_b.done; _b = _a.next()) {
                                m = _b.value;
                                requestCache = m.middleware(requestCache);
                            }
                        }
                        catch (e_4_1) { e_4 = { error: e_4_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
                            }
                            finally { if (e_4) throw e_4.error; }
                        }
                        responseCache = null;
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 3, , 4]);
                        if (!requestCache.headers) {
                            requestCache.headers = {};
                        }
                        else {
                            requestCache.headers = Object.keys(requestCache.headers).reduce(function (acc, key) {
                                acc[key.toLowerCase()] = requestCache.headers[key];
                                return acc;
                            }, {});
                        }
                        return [4, this.driver(requestCache)];
                    case 2:
                        responseCache = _k.sent();
                        return [3, 4];
                    case 3:
                        e_3 = _k.sent();
                        failureCache = e_3;
                        try {
                            for (_c = __values(this.responseMiddlewareChain), _d = _c.next(); !_d.done; _d = _c.next()) {
                                m = _d.value;
                                failureCache = m.middleware(failureCache);
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_h = _c.return)) _h.call(_c);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        throw failureCache;
                    case 4:
                        try {
                            for (_e = __values(this.responseMiddlewareChain), _f = _e.next(); !_f.done; _f = _e.next()) {
                                m = _f.value;
                                responseCache = m.middleware(responseCache);
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_j = _e.return)) _j.call(_e);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                        return [2, responseCache];
                }
            });
        }); };
    }
    return NetworkingLayer;
}());
exports.NetworkingLayer = NetworkingLayer;
